const styles = {
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
    sendLink_Btn: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        borderRadius: '16px',
        fontSize: '16px',
        textTransform: 'none',
        marginTop: '40px',
        backgroundColor: '#3876AA',
        color: '#FFFFFF',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '28px',
        lineHeight: '42px',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
        marginBottom: '8px',
        color: '#3876AA',
    },
    description: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#27344E',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '24px',
        marginBottom: '24px',
    },
    backBtn: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        color: '#001533',
        background: '#F7F8FC',
        padding: '4px',
        borderRadius: 2,
        marginBottom: '24px',
        textDecoration: 'none',
    },
};
export default styles;
